let CONNECTED_ERRORS_TAB = {
  options: {
    tabName: 'connectedErrors',
    uri: '/connectedErrors'
  },
  columns: [{
    name: 'message', 
    label: 'Issue',
    formatFilter: 'uppercase',
    type: 'table-grid-text-cell'
  },{
    name: 'count',  
    label: 'Instances',
    type: 'table-grid-text-cell'
  }]
};
  
export
default CONNECTED_ERRORS_TAB;


// WEBPACK FOOTER //
// ./app/models/connectedErrorTab.js